import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    routes: [
        // {
        //   path: '/',
        //   name: 'HelloWorld',
        //   component: HelloWorld
        // },
        {
            path: '/',
            component: (resolve) => require(['@/views/translate/index.vue'], resolve),
            hidden: true
        },
        {
            path: '/code2',
            component: (resolve) => require(['@/views/translate/code2.vue'], resolve),
            hidden: true
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js